import { HttpStatusCode } from "axios";
import { ApiRequest } from "../../Handlers/ApiReqest";
import { InstitutionData } from "../../Interfaces/ResponsesData";
import { InterActive } from "../../utilities/ViewModelStructure";
import { Notify } from "../../Handlers/Notifications";

export class InstitutionsListVM extends InterActive{
    private inistutions?:InstitutionData
    private newElement:string = ''
    private selectedInstitution:string = ''
    private refresh:number = 0
    private courseToAttach:string = ''
    private levelSpecializationToAttach:string = ''

    public get Data():InstitutionData|undefined { return this.inistutions }
    public get NewElement():string { return this.newElement }
    public get SelectedInstitution():string { return this.selectedInstitution }
    public get Refresh():number{ return this.refresh }
    public get CourseToAttach():string { return this.courseToAttach }
    public get LevelSpecializationToAttach():string { return this.levelSpecializationToAttach }

    public set NewElement(value:string) { this.newElement = value; this.update() }
    public set SelectedInstitution(value:string){this.checkSelectedInstitution(value) ; this.update() }
    public set CourseToAttach(value:string) { this.courseToAttach = value; this.update() }
    public set LevelSpecializationToAttach(value:string) { this.levelSpecializationToAttach = value; this.update() }


    public load(){
        this.loading(
            async()=>{
                try{
                    const response = await ApiRequest.getAllInstitutionsData()
                    if(response){
                        if(response.status === HttpStatusCode.Ok){
                            if(response.data.status){
                                this.newElement = ''
                                this.inistutions = response.data.data; 
                                this.checkSelectedInstitution(this.selectedInstitution)
                                /*if(this.inistutions.data.length>0){
                                    //alert(this.selectedInstitution)
                                    if(this.selectedInstitution.length === 0)this.selectedInstitution=this.inistutions.data[0].id
                                    else {
                                        if((this.inistutions.data.length <= Number(this.selectedInstitution))){
                                            alert('length = '+this.inistutions.data.length+' , selected = '+Number(this.selectedInstitution))
                                            this.selectedInstitution=this.inistutions.data[0].id
                                        }
                                        else alert('ok'+this.selectedInstitution)
                                    }
                                }*/
                                this.update()
                            }else Notify({type:'danger' , title:'مشكلة' , body:response.data.messege})
                        }else Notify({type:'danger' , title:'مشكلة فى الاتصال' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                    }
                }catch { Notify({type:'danger' , title:'مشكلة فى الاتصال' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'}) }}
        )
    }
    private checkSelectedInstitution(value:string){
        const exists = this.inistutions?.data.some(a=>a.id===value)
        if(exists){
            this.selectedInstitution = value
        }else {
            if(this.inistutions &&  this.inistutions?.data.length > 0){
                this.selectedInstitution = this.inistutions.data[0].id
            }else this.selectedInstitution = ''
        }
        this.courseToAttach = ''
        this.levelSpecializationToAttach = ''
    }
    public addInistitution(){
        if(this.newElement){
        this.loading(
            async()=>{
                try{
                    const response = await ApiRequest.addInstitution(this.newElement)
                    if(response){
                        if(response.status === HttpStatusCode.Ok){
                            if(response.data.status){
                                this.refresh++
                                this.update()
                            }else Notify({type:'danger' , title:'مشكلة' , body:response.data.messege})
                        }else Notify({type:'danger' , title:'مشكلة فى الاتصال' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                    }
                }catch{
                     Notify({type:'danger' , title:'مشكلة فى الاتصال' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                }
            }
        )
        }
    }
    public deleteInistitution(id:string){
        if(this.newElement){
        this.loading(
            async()=>{
                try{
                    const response = await ApiRequest.deleteInistitution(id)
                    if(response){
                        if(response.status === HttpStatusCode.Ok){
                            if(response.data.status){
                                this.refresh++
                                this.update()
                            }else Notify({type:'danger' , title:'مشكلة' , body:response.data.messege})
                        }else Notify({type:'danger' , title:'مشكلة فى الاتصال' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                    }
                }catch{
                     Notify({type:'danger' , title:'مشكلة فى الاتصال' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                }
            }
        )
        }
    }
    public attachCourse(){
        if(this.courseToAttach && this.selectedInstitution){
            this.loading(
                async()=>{
                    try{
                        const response = await ApiRequest.attachCourseToInstitution(this.selectedInstitution,this.courseToAttach)
                        if(response){
                            if(response.status === HttpStatusCode.Ok){
                                if(response.data.status){
                                    this.refresh++
                                    this.update()
                                }else Notify({type:'danger' , title:'مشكلة' , body:response.data.messege})
                            }else Notify({type:'danger' , title:'مشكلة فى الاتصال' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                        }
                    }catch{
                         Notify({type:'danger' , title:'مشكلة فى الاتصال' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                    }
                }
            )
        }
    }
    public detachCourseFromInstitution( course_id:string){
        if( course_id && this.selectedInstitution){
            
            this.loading(
                async()=>{
                    try{
                        const response = await ApiRequest.detachCourseFromInstitution(this.selectedInstitution,course_id)
                        if(response){
                            if(response.status === HttpStatusCode.Ok){
                                if(response.data.status){
                                    this.refresh++
                                    this.update()
                                }else Notify({type:'danger' , title:'مشكلة' , body:response.data.messege})
                            }else Notify({type:'danger' , title:'مشكلة فى الاتصال' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                        }
                    }catch{
                         Notify({type:'danger' , title:'مشكلة فى الاتصال' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                    }
                }
            )
        }
    }

    public attachLevelSpecialization(){
        if(this.levelSpecializationToAttach && this.selectedInstitution){
            this.loading(
                async()=>{
                    try{
                        const response = await ApiRequest.attachLevelSpecializationToInstitution(this.selectedInstitution,this.levelSpecializationToAttach)
                        if(response){
                            if(response.status === HttpStatusCode.Ok){
                                if(response.data.status){
                                    this.refresh++
                                    this.update()
                                }else Notify({type:'danger' , title:'مشكلة' , body:response.data.messege})
                            }else Notify({type:'danger' , title:'مشكلة فى الاتصال' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                        }
                    }catch{
                         Notify({type:'danger' , title:'مشكلة فى الاتصال' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                    }
                }
            )
        }
    }
    public detachLevelSpecializationFromInstitution( level_specialization_id:string){
        if( this.selectedInstitution && level_specialization_id){
            this.loading(
                async()=>{
                    try{
                        const response = await ApiRequest.detachLevelSpecializationFromInstitution(this.selectedInstitution,level_specialization_id)
                        if(response){
                            if(response.status === HttpStatusCode.Ok){
                                if(response.data.status){
                                    this.refresh++
                                    this.update()
                                }else Notify({type:'danger' , title:'مشكلة' , body:response.data.messege})
                            }else Notify({type:'danger' , title:'مشكلة فى الاتصال' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                        }
                    }catch{
                         Notify({type:'danger' , title:'مشكلة فى الاتصال' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                    }
                }
            )
        }
    }
}